import React from "react";

export default function Footer() {
  return (
    <footer className="w-full text-center text-gray-600 text-sm mt-8 py-4 border-t border-gray-200">
      <p>
        Copyright © GBU | OHMS 2023-2026 <br />
        Designed & Developed By{" "}
        <a
          href="https://faculty.gbu.ac.in/team.php"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline"
        >
          Abhay Srivastava
        </a>{" "}
        &{" "}
        <a
          href="https://faculty.gbu.ac.in/team.php"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline"
        >
          Prashant Tiwari
        </a>
      </p>
    </footer>
  );
}
